module.exports = __webpack_public_path__ + "img/20190620162101401.2ab5fa2d.png";